import { DropdownInput, Input, TextArea } from "@snapchat/snap-design-system";

import { ReadOnlyInput } from "../components";
import { formikAdapter } from "../utils/formik";

export const FormikInput = formikAdapter(Input);
export const FormikDropdownInput = formikAdapter(DropdownInput);
export const FormikReadOnlyInput = formikAdapter(ReadOnlyInput);
export const FormikTextArea = formikAdapter(TextArea);
